import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GlueConfigurationService } from './glue-configuration.service';

@Injectable({
  providedIn: 'root',
})
export class TermsService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly glueConfiguration: GlueConfigurationService = inject(GlueConfigurationService);

  private readonly termsAcceptUrl: string = this.glueConfiguration.getEndpointUrl() + `/terms`;

  private static handleOrderError(error: any): Promise<any> {
    return Promise.reject(error.message || error);
  }

  postAcceptTerms(data: any): Observable<any> {
    return this.httpClient.post<any>(this.termsAcceptUrl, data).pipe(
      catchError(TermsService.handleOrderError));
  }
}
